import React, { createContext, useContext } from 'react';
import { BoxProps, TextProps, Field } from '@chakra-ui/react';

interface FormControlContextValue {
    isInvalid?: boolean;
    isRequired?: boolean;
}

const FormControlContext = createContext<FormControlContextValue>({});

export type FormControlProps = BoxProps & {
    isInvalid?: boolean;
    isRequired?: boolean;
};

export const FormControl: React.FC<FormControlProps> = ({ children, isInvalid, isRequired, ...props }) => (
    <FormControlContext.Provider value={{ isInvalid, isRequired }}>
        <Field.Root invalid={isInvalid} required={isRequired} {...props}>
            {children}
        </Field.Root>
    </FormControlContext.Provider>
);

const useFormControlContext = () => useContext(FormControlContext);

export type FormLabelProps = TextProps & {
    children?: React.ReactNode;
};

export const FormLabel: React.FC<FormLabelProps> = ({ children, ...props }) => {
    return (
        <Field.Label fontWeight="semibold" fontSize="sm" {...props}>
            {children}
            <Field.RequiredIndicator />
        </Field.Label>
    );
};

export type FormErrorMessageProps = TextProps & {
    children?: React.ReactNode;
};

export const FormErrorMessage: React.FC<FormErrorMessageProps> = ({ children, ...props }) => {
    const { isInvalid } = useFormControlContext();
    if (!isInvalid) return null;
    return (
        <Field.ErrorText color="red.500" fontSize="sm" {...props}>
            {children}
        </Field.ErrorText>
    );
};

export type FormHelperTextProps = TextProps & {
    children?: React.ReactNode;
};

export const FormHelperText: React.FC<FormHelperTextProps> = ({ children, ...props }) => (
    <Field.HelperText fontSize="sm" color="gray.500" {...props}>
        {children}
    </Field.HelperText>
);
